import React, { useState, useEffect } from 'react';



const rawHTML = `
<!DOCTYPE html>
<html>

<head>
	<title></title>
	<meta content="summary_large_image" name="twitter:card" />
	<meta content="website" property="og:type" />
	<meta content="" property="og:description" />
	<meta content="https://v1sjp8jkro.preview-postedstuff.com/V2-Le0t-NyNd-fgRY-4puL/" property="og:url" />
	<meta content="https://pro-bee-beepro-thumbnail.getbee.io/messages/907814/892129/1812946/9106986_large.jpg" property="og:image" />
	<meta content="" property="og:title" />
	<meta content="" name="description" />
	<meta charset="utf-8" />
	<meta content="width=device-width" name="viewport" />
	<style>
		.bee-row,
		.bee-row-content {
			position: relative
		}

		.bee-row-3,
		.bee-row-3 .bee-row-content {
			background-color: #000
		}

		body {
			background-color: #fff;
			color: #000;
			font-family: Arial, Helvetica, sans-serif
		}

		.bee-row-3 .bee-col-1 .bee-block-1 a,
		a {
			color: #8a3c90
		}

		* {
			box-sizing: border-box
		}

		body,
		h1,
		p {
			margin: 0
		}

		.bee-row-content {
			max-width: 1280px;
			margin: 0 auto;
			display: flex
		}

		.bee-row-content.reverse,
		.bee-row-content.reverse .bee-col {
			-moz-transform: scale(1, -1);
			-webkit-transform: scale(1, -1);
			-o-transform: scale(1, -1);
			-ms-transform: scale(1, -1);
			transform: scale(1, -1)
		}

		.bee-row-content .bee-col-w12 {
			flex-basis: 100%
		}

		.bee-icon .bee-icon-label-right a {
			text-decoration: none
		}

		.bee-image {
			overflow: auto
		}

		.bee-image .bee-center {
			margin: 0 auto
		}

		.bee-row-1 .bee-col-1 .bee-block-1 {
			width: 100%
		}

		.bee-row-1 .bee-row-content,
		.bee-row-2 .bee-row-content,
		.bee-row-3 .bee-row-content {
			border-radius: 0;
			background-repeat: no-repeat;
			color: #000
		}

		.bee-icon {
			display: inline-block;
			vertical-align: middle
		}

		.bee-icon .bee-content {
			display: flex;
			align-items: center
		}

		.bee-image img {
			display: block;
			width: 100%
		}

		.bee-paragraph {
			overflow-wrap: anywhere
		}

		.bee-row-1,
		.bee-row-2,
		.bee-row-4 {
			background-repeat: no-repeat
		}

		.bee-row-1 .bee-col-1,
		.bee-row-2 .bee-col-1,
		.bee-row-3 .bee-col-1,
		.bee-row-4 .bee-col-1 {
			padding-bottom: 5px;
			padding-top: 5px
		}

		.bee-row-2 .bee-col-1 .bee-block-1 {
			padding: 10px;
			text-align: center;
			width: 100%
		}

		.bee-row-2 .bee-col-1 .bee-block-2,
		.bee-row-3 .bee-col-1 .bee-block-1 {
			padding: 10px
		}

		.bee-row-3 {
			background-repeat: no-repeat
		}

		.bee-row-4 .bee-row-content {
			background-repeat: no-repeat;
			color: #000
		}

		.bee-row-4 .bee-col-1 .bee-block-1 {
			color: #9d9d9d;
			font-family: inherit;
			font-size: 15px;
			padding-bottom: 5px;
			padding-top: 5px;
			text-align: center
		}

		.bee-row-2 .bee-col-1 .bee-block-2,
		.bee-row-3 .bee-col-1 .bee-block-1 {
			direction: ltr;
			font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
			font-weight: 400;
			letter-spacing: 0;
			text-align: left
		}

		.bee-row-2 .bee-col-1 .bee-block-2 {
			color: #101112;
			font-size: 13px;
			line-height: 120%
		}

		.bee-row-2 .bee-col-1 .bee-block-2 a {
			color: #3e6497
		}

		.bee-row-2 .bee-col-1 .bee-block-2 p:not(:last-child),
		.bee-row-3 .bee-col-1 .bee-block-1 p:not(:last-child) {
			margin-bottom: 4px
		}

		.bee-row-4 .bee-col-1 .bee-block-1 .bee-icon-image {
			padding: 5px 6px 5px 5px
		}

		.bee-row-4 .bee-col-1 .bee-block-1 .bee-icon:not(.bee-icon-first) .bee-content {
			margin-left: 0
		}

		.bee-row-4 .bee-col-1 .bee-block-1 .bee-icon::not(.bee-icon-last) .bee-content {
			margin-right: 0
		}

		.bee-row-3 .bee-col-1 .bee-block-1 {
			color: #fff;
			font-size: 16px;
			line-height: 150%
		}

		@media (max-width:768px) {
			.bee-row-content:not(.no_stack) {
				display: block
			}

			.bee-row-2 .bee-col-1 .bee-block-2 {
				padding: 10px 20px !important;
				font-size: 13px !important
			}

			.bee-row-3 .bee-col-1 .bee-block-1 {
				padding: 5px 25px !important;
				font-size: 11px !important
			}

			.bee-row-1 .bee-col-1 .bee-block-1 img {
				float: none !important;
				margin: 0 auto !important
			}

			.bee-row-2 .bee-col-1 .bee-block-1 {
				text-align: center !important
			}

			.bee-row-2 .bee-col-1 .bee-block-1 h1 {
				font-size: 16px !important;
				text-align: center !important
			}
		}
	</style>
</head>

<body>
	<div class="bee-page-container">
		<div class="bee-row bee-row-1">
			<div class="bee-row-content">
				<div class="bee-col bee-col-1 bee-col-w12">
					<div class="bee-block bee-block-1 bee-image"><img alt="" class="bee-center bee-fixedwidth" src="https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/907814_892129/image-removebg-preview%20%281%29.png" style="max-width:256px;" /></div>
				</div>
			</div>
		</div>
		<div class="bee-row bee-row-2">
			<div class="bee-row-content">
				<div class="bee-col bee-col-1 bee-col-w12">
					<div class="bee-block bee-block-1 bee-heading">
						<h1 style="color:#101112;direction:ltr;font-family:Arial, 'Helvetica Neue', Helvetica, sans-serif;font-size:38px;font-weight:700;letter-spacing:normal;line-height:120%;text-align:left;margin-top:0;margin-bottom:0;"><span class="tinyMce-placeholder">Uniserved Tech Solutions Pvt. Ltd Terms of Service</span> </h1>
					</div>
					<div class="bee-block bee-block-2 bee-paragraph">
						<p><strong>1. Terms</strong></p>
						<p>By accessing the website at <a href="http://uniserved.com/" style="text-decoration: underline;">http://uniserved.com</a>, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.</p>
						<p><strong>2. Use License</strong></p>
						<p><strong>a.</strong> Permission is granted to temporarily download one copy of the materials (information or software) on Uniserved Tech Solutions Pvt. Ltd's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
						<p>  <strong>1</strong>. Modify or copy the materials;</p>
						<p><strong>  2</strong>. Use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</p>
						<p>  <strong>3</strong>. Attempt to decompile or reverse engineer any software contained on Uniserved Tech Solutions Pvt. Ltd's website;</p>
						<p> <strong> 4</strong>. Remove any copyright or other proprietary notations from the materials; or</p>
						<p>  <strong>5</strong>.Transfer the materials to another person or "mirror" the materials on any other server.</p>
						<p><strong>b. </strong>This license shall automatically terminate if you violate any of these restrictions and may be terminated by Uniserved Tech Solutions Pvt. Ltd at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</p>
						<p><strong>3. Disclaimer</strong></p>
						<p><strong>a.</strong> The materials on Uniserved Tech Solutions Pvt. Ltd's website are provided on an 'as is' basis. Uniserved Tech Solutions Pvt. Ltd makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
						<p><strong>b.</strong> Further, Uniserved Tech Solutions Pvt. Ltd does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</p>
						<p><strong>4. Limitations</strong></p>
						<p>In no event shall Uniserved Tech Solutions Pvt. Ltd or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Uniserved Tech Solutions Pvt. Ltd's website, even if Uniserved Tech Solutions Pvt. Ltd or a Uniserved Tech Solutions Pvt. Ltd authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>
						<p><strong>5. Accuracy of materials</strong></p>
						<p>The materials appearing on Uniserved Tech Solutions Pvt. Ltd website could include technical, typographical, or photographic errors. Uniserved Tech Solutions Pvt. Ltd does not warrant that any of the materials on its website are accurate, complete or current. Uniserved Tech Solutions Pvt. Ltd may make changes to the materials contained on its website at any time without notice. However Uniserved Tech Solutions Pvt. Ltd does not make any commitment to update the materials.</p>
						<p><strong>6. Links</strong></p>
						<p>Uniserved Tech Solutions Pvt. Ltd has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Uniserved Tech Solutions Pvt. Ltd of the site. Use of any such linked website is at the user's own risk.</p>
						<p><strong>7. Modifications</strong></p>
						<p>Uniserved Tech Solutions Pvt. Ltd may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>
						<p><strong>8. Governing Law</strong></p>
						<p>These terms and conditions are governed by and construed in accordance with the laws of Maharashtra and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
					</div>
				</div>
			</div>
		</div>
		<div class="bee-row bee-row-3">
			<div class="bee-row-content">
				<div class="bee-col bee-col-1 bee-col-w12">
					<div class="bee-block bee-block-1 bee-paragraph">
						<p>UNISERVED</p>
						<p>We are a Technology Infrastructure platform which uses Enterprise Crowdsourcing to ensure you have the skilled resources where you need them at the right price.</p>
						<p>Helping drive the vision of a Digital India, one project at a time!</p>
						<p> </p>
						<p><span style="color: #434854;">© Copyright 2019 Uniserved Tech Solutions Pvt Ltd (A Savex Group Company)</span></p>
					</div>
				</div>
			</div>
		</div>
</body>

</html>
`;

const TermsandConditions = () => {
	return (
		// <div style={container}>
			<div dangerouslySetInnerHTML={{ __html: rawHTML }} style={{overflowY:'scroll', maxHeight:"100%"}}></div>
		// </div>
	);
};

export default TermsandConditions;

